export default function () {
    new Swiper(".explore_our_work__swiper", {
        spaceBetween: 24,
        slidesPerView: 1,
        navigation: {
            nextEl: ".explore_our_work__swiper__btn.next",
            prevEl: ".explore_our_work__swiper__btn.prev",
        },
        breakpoints: {
            768: {
                slidesPerView: 'auto',
            },
            1280: {
                slidesPerView: 3
            },
        }
    });
}